var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgHome(props) {
    return (React.createElement("svg", __assign({ viewBox: '-4 0 50 48' }, props),
        React.createElement("path", { fillRule: 'evenodd', d: 'M22.083.45L41.55 19.955c.287.287.449.678.449 1.084v25.426c0 .848-.686 1.535-1.532 1.535H1.532A1.533 1.533 0 010 46.465V21.04c0-.406.161-.797.448-1.084L19.917.45a1.53 1.53 0 012.166 0zm-.134 2.977a1.393 1.393 0 00-1.957 0L2.405 20.842A1.36 1.36 0 002 21.81v22.702c0 .757.62 1.37 1.384 1.37h35.173c.765 0 1.384-.613 1.384-1.37V21.81c0-.363-.146-.711-.405-.968z' })));
}
export default SvgHome;
//# sourceMappingURL=Home.js.map